<template>
  <div class="loader" />
</template>

<style scoped>
/* HTML: <div class="loader"></div> */
.loader {
  width: 60px;
  aspect-ratio: 1;
  --g: conic-gradient(from -90deg at 10px 10px, #1e2733 90deg, #0000 0);
  background: var(--g), var(--g), var(--g);
  background-size: 50% 50%;
  animation: l16 1s infinite;
}
@keyframes l16 {
  0% {
    background-position: 20px 20px, 10px 10px, 0 0;
  }
  50% {
    background-position: 0 20px, 10px 10px, 20px 0;
  }
  100% {
    background-position: 0 0, 10px 10px, 20px 20px;
  }
}
</style>
